<!-- @format -->

<app-create-asin-header></app-create-asin-header>

<div
	class="land-bg"
	style="{{ minHeight }}"
>
	<div
		class="container mb-4"
		style="{{ minHeight2 }}"
	>
		<div
			*ngIf="vStage1"
			style="padding: 50px 30px"
		>
			<div class="row justify-content-center">
				<div class="col-md-4">
					<div class="question-card">
						<p class="text-muted fs-bolder">ACCOUNT VERIFICATION</p>
						<div class="d-flex flex-row align-items-center mb-3">
							<!-- <div
								class="d-flex flex-row align-items-center me-4"
							>
								<label class="me-2">Email</label>
								<input
									class="radio-group"
									name="emailPhone"
									(click)="TChannel('email')"
									type="radio"
									[value]="'email'"
								/>
							</div> -->
							<!-- <div class="d-flex flex-row align-items-center">
                                <label class="me-2">SMS</label>
                                <input class="radio-group" name="emailPhone" (click)="TChannel('sms')" type="radio" />
                            </div> -->
						</div>
						<div
							class="loader"
							*ngIf="isLoading"
						>
							<div class="spinner"></div>
						</div>
						<i
							style="
								font-size: 15px;
								color: #356229;
								margin-bottom: 10px;
								text-align: center;
							"
							>{{ codeSentMSG }}</i
						>
						<br />
						<div class="d-flex flex-row justify-content-center">
							<button
								class="bg-dark me-2"
								style="padding: 10px 50px !important"
								(click)="backStep()"
							>
								Back
							</button>
							<button
								[disabled]="!isCodeReady"
								style="padding: 10px 50px !important"
								(click)="tvStage(2)"
							>
								Proceed
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			*ngIf="vStage2"
			style="padding: 50px 30px"
		>
			<div class="row justify-content-center">
				<div class="col-md-5">
					<div class="question-card">
						<div *ngIf="emailPhone === 'email'">
							<svg
								width="59"
								height="52"
								viewBox="0 0 59 52"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M38.7578 51.0252L27.7873 40.0547L29.9703 37.8717L38.7578 46.6592L56.2958 29.1212L58.4788 31.3011L38.7578 51.0252ZM28 19.3594L51.717 3.94271H4.283L28 19.3594ZM28 22.8004L3.33333 6.67146V39.0465C3.33333 39.5994 3.51114 40.0537 3.86675 40.4093C4.22236 40.7649 4.67767 40.9427 5.23267 40.9427H19.9833L23.0667 44.026H5.23267C3.81228 44.026 2.62725 43.5512 1.67758 42.6015C0.727917 41.6519 0.252056 40.4658 0.25 39.0434V5.84204C0.25 4.42165 0.725861 3.23662 1.67758 2.28696C2.62931 1.33729 3.81331 0.861431 5.22958 0.859375H50.7704C52.1888 0.859375 53.3728 1.33524 54.3224 2.28696C55.2721 3.23868 55.7479 4.42371 55.75 5.84204V21.0305L52.6667 24.1139V6.67146L28 22.8004Z"
									fill="#C59F38"
								/>
							</svg>
						</div>
						<div *ngIf="emailPhone === 'sms'">
							<svg
								width="65"
								height="66"
								viewBox="0 0 65 66"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M59.5833 14.0859H43.3333M43.3333 14.0859L51.4583 5.96094M43.3333 14.0859L51.4583 22.2109M49.0695 40.3622L37.9166 42.5234C30.382 38.7426 25.7291 34.3984 23.0208 27.6276L25.1062 16.4422L21.1656 5.96094H11.0066C7.95161 5.96094 5.54661 8.4851 6.00431 11.5049C7.14181 19.0422 10.5001 32.7111 20.3124 42.5234C30.6177 52.8286 45.462 57.3001 53.6304 59.0795C56.7856 59.7647 59.5833 57.3055 59.5833 54.0745V44.3678L49.0695 40.3622Z"
									stroke="#C59F38"
									stroke-width="3"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>

						<br />

						<p
							class="mb-2"
							style="font-size: 20px"
						>
							Verify your email address to create
						</p>
						<p style="font-size: 20px">your new ASIN</p>
						<small class="mb-0"
							>An email with a verification code has been
							sent</small
						>
						<small *ngIf="emailPhone === 'email'"
							>to
							{{
								form.get("businessDetails")?.get("email")?.value
							}}</small
						>
						<small *ngIf="emailPhone === 'sms'"
							>+234
							{{
								form.get("businessDetails")?.get("phone")?.value
							}}</small
						>
						<br />
						<small class="mb-2">Please enter the code here</small>

						<div class="row justify-content-center">
							<div class="col-md-7">
								<div class="d-flex flex-row mb-3">
									<input
										[(ngModel)]="digit1"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 0)"
										class="number-box me-2"
										appOnlyNumber
									/>
									<input
										[(ngModel)]="digit2"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 1)"
										class="number-box me-2"
										appOnlyNumber
									/>
									<input
										[(ngModel)]="digit3"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 2)"
										class="number-box me-2"
										appOnlyNumber
									/>
									<input
										[(ngModel)]="digit4"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 3)"
										class="number-box me-2"
										appOnlyNumber
									/>
									<input
										[(ngModel)]="digit5"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 4)"
										class="number-box me-2"
										appOnlyNumber
									/>
									<input
										[(ngModel)]="digit6"
										maxlength="1"
										#inputField
										(keyup)="nextInput($event, 5)"
										class="number-box"
										appOnlyNumber
									/>
								</div>
							</div>
						</div>

						<a
							[ngClass]="isCountDown ? 'resend2' : 'resend'"
							href="javascript:void(0)"
							class="mb-2"
							(click)="TChannel('email')"
							*ngIf="emailPhone === 'email'"
							>Did not get the email? Resend:
							<b>{{ countdownSeconds }}</b></a
						>
						<a
							[ngClass]="isCountDown ? 'resend2' : 'resend'"
							href="javascript:void(0)"
							class="mb-2"
							(click)="TChannel('sms')"
							*ngIf="emailPhone === 'phone'"
							>Did not get the SMS? Resend:
							<b>{{ countdownSeconds }}</b></a
						>

						<p style="font-size: 13px">{{ codeConfirmMSG }}</p>
						<div class="button-section">
							<button
								class="bg-dark me-3"
								(click)="prevStage()"
							>
								Cancel
							</button>
							<button
								style="background: #cc9e0a; color: #fff"
								(click)="submit()"
							>
								Continue
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			*ngIf="vStage3"
			style="padding: 50px 30px"
		>
			<div class="row justify-content-center">
				<div class="col-md-4">
					<div class="question-card">
						<div>
							<svg
								width="74"
								height="75"
								viewBox="0 0 74 75"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M31.9043 54.463L57.7487 28.6187L52.6165 23.4865L31.9043 44.1986L21.4566 33.7509L16.3244 38.8831L31.9043 54.463ZM37.0365 74.2586C31.9654 74.2586 27.1998 73.2957 22.7397 71.3699C18.2796 69.4441 14.3999 66.8328 11.1006 63.536C7.8013 60.2367 5.18998 56.357 3.26663 51.8969C1.34327 47.4367 0.380374 42.6711 0.37793 37.6C0.37793 32.5289 1.34083 27.7633 3.26663 23.3032C5.19243 18.843 7.80374 14.9633 11.1006 11.6641C14.3999 8.36478 18.2796 5.75346 22.7397 3.83011C27.1998 1.90675 31.9654 0.94385 37.0365 0.941406C42.1077 0.941406 46.8733 1.90431 51.3334 3.83011C55.7935 5.75591 59.6732 8.36722 62.9725 11.6641C66.2718 14.9633 68.8843 18.843 70.8101 23.3032C72.7359 27.7633 73.6976 32.5289 73.6952 37.6C73.6952 42.6711 72.7323 47.4367 70.8065 51.8969C68.8807 56.357 66.2693 60.2367 62.9725 63.536C59.6732 66.8353 55.7935 69.4478 51.3334 71.3736C46.8733 73.2994 42.1077 74.2611 37.0365 74.2586Z"
									fill="#52BA4A"
								/>
							</svg>
						</div>

						<br />
						<p
							class="mb-2"
							style="font-size: 20px"
						>
							Successful
						</p>

						<small class="mb-0"
							>Click continue to complete your corporate</small
						>
						<small>enumeration process</small>
						<br />
						<div class="button-section">
							<button (click)="moveToNext()">Continue</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<app-footer></app-footer>
</div>
